import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { MojitoAccessResponse } from '../../shared/models/mojito-access.model';

/**
 * La llamada de entrada desde Mojito360 (`POST /api/mojito-access`). El backend
 * comprueba que el usuario pertenece a esa entidad de Mojito, busca la entidad
 * de Mojito BI enlazada y, si hace falta, le asigna el rol Visualizador.
 *
 * Sin `providedIn`: la provee la ruta `from-mojito`, que es la única que la usa.
 * Se llama fuera de `:companyCode`, así que no viaja `x-company-id`.
 */
@Injectable()
export class MojitoAccessApiService {
  private readonly http = inject(HttpClient);

  requestAccess(mojitoCompanyId: number): Observable<MojitoAccessResponse> {
    return this.http.post<MojitoAccessResponse>(
      `${environment.baseBackendUrl}/api/mojito-access`,
      { mojitoCompanyId },
    );
  }
}
